import {post} from '@/utils/request';
import {erpserver,erpplatserver,oaserver,sse_url} from '@/utils/baseUrl';


//列表
export async function getPzcheckList(params) {
    return post(erpserver+'/assay/getPzcheckList', params, true);
}
//详情
export async function getPzcheckDetail(params) {
    return post(erpserver+'/assay/getPzcheckDetail', params, true);
}
//字典表 状态\类型
export async function selectPz(params) {
    return post(erpserver+'/assay/selectPz', params, true);
}
export async function selectPzclass(params) {
    return post(erpserver+'/assay/selectPzclass', params, true);
}
export async function selectGsz(params) {
    return post(erpserver+'/assay/selectGsz', params, true);
}
//baocun
export async function savePzcheck(params) {
    return post(erpserver+'/assay/savePzcheck', params, true);
}
//删除
export async function deletePzcheck(params) {
    return post(erpserver+'/assay/deletePzcheck', params, true);
}
